module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "text-xs-left"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Completa los datos")]), _vm._v(" "), (!_vm.$v.user.activeEmployement.required) ? _c('p', {
    staticClass: "caption red--text"
  }, [_vm._v("Seleccionar cargo al usuario")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "employment-grid"
  }, _vm._l((_vm.listEmploye), function(emp, indexEmp) {
    return _c('employment-component', {
      key: indexEmp,
      attrs: {
        "title": emp.name,
        "icon": emp.urlImage[0],
        "id": emp.id,
        "employee-active": _vm.user.activeEmployement
      },
      on: {
        "selected-employ": _vm.loadEmployeesNew
      }
    })
  })), _vm._v(" "), _c('label', {
    staticClass: "employ-info"
  }, [_vm._v(_vm._s(_vm.contentX))])]), _vm._v(" "), _c('hr', {
    staticClass: "section-spacer my-4"
  }), _vm._v(" "), _c('section', {
    staticClass: "complete-data text-xs-left mt-3"
  }, [_c('v-switch', {
    staticClass: "input-switch",
    attrs: {
      "hide-details": "",
      "label": "Complete los Datos",
      "color": "success"
    },
    model: {
      value: (_vm.completeDataActive),
      callback: function($$v) {
        _vm.completeDataActive = $$v
      },
      expression: "completeDataActive"
    }
  }), _vm._v(" "), (_vm.completeDataActive) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Nombre",
      "placeholder": "Nombre"
    },
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.user.name = $$v
      },
      expression: "user.name"
    }
  }), _vm._v(" "), (!_vm.$v.user.name.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tCampo Requerido\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Apellido",
      "placeholder": "Apellido"
    },
    model: {
      value: (_vm.user.lastname),
      callback: function($$v) {
        _vm.user.lastname = $$v
      },
      expression: "user.lastname"
    }
  }), _vm._v(" "), (!_vm.$v.user.lastname.required) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("\n\t\t\t\t\tCampo Requerido\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-date', {
    attrs: {
      "label": "",
      "labelText": "Fecha de naciemiento"
    },
    model: {
      value: (_vm.user.dateBirth),
      callback: function($$v) {
        _vm.user.dateBirth = $$v
      },
      expression: "user.dateBirth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('select-button', {
    attrs: {
      "label": "",
      "labelText": "Género",
      "itemText": "name",
      "itemValue": "id",
      "items": _vm.genders
    },
    model: {
      value: (_vm.user.gender),
      callback: function($$v) {
        _vm.user.gender = $$v
      },
      expression: "user.gender"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Correo",
      "placeholder": "Correo",
      "type": "email"
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.user.email = $$v
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (!_vm.validateEmail(_vm.user.email)) ? _c('span', {
    staticClass: "text-validate"
  }, [_vm._v("\n\t\t\t\t\tIngrese Email valido\n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Teléfono",
      "placeholder": "Teléfono",
      "type": "number"
    },
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.user.phone = $$v
      },
      expression: "user.phone"
    }
  }), _vm._v(" "), (!_vm.$v.user.phone.minLength) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("mínimo 6 digitos")]) : _vm._e(), _vm._v(" "), (!_vm.$v.user.phone.maxLength) ? _c('span', {
    staticClass: "caption red--text"
  }, [_vm._v("maximo 11 digitos")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-3": ""
    }
  }, [_c('input-text', {
    attrs: {
      "label": "",
      "label-text": "Codigo ACL",
      "placeholder": "Codigo ACL",
      "type": "text"
    },
    model: {
      value: (_vm.user.aclCode),
      callback: function($$v) {
        _vm.user.aclCode = $$v
      },
      expression: "user.aclCode"
    }
  }), _vm._v(" "), (!_vm.$v.user.aclCode.required) ? _c('span', {
    staticClass: "text-validate"
  }, [_vm._v("\n\t\t\t\t\tIngrese Codigo \n\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "text-xs-left": "",
      "mb-2": "",
      "mr-4": "",
      "mt-3": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select filter-select-autocomplete filter-select-indicator",
    attrs: {
      "items": _vm.typeDocument,
      "autocomplete": "",
      "item-text": "code",
      "item-value": "id",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.user.documentType),
      callback: function($$v) {
        _vm.user.documentType = $$v
      },
      expression: "user.documentType"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-border-inset input-form-select",
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.user.numDocument),
      callback: function($$v) {
        _vm.user.numDocument = $$v
      },
      expression: "user.numDocument"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('section', {
    staticClass: "text-xs-left mb-3"
  }, [_c('label', {
    staticClass: "label-title"
  }, [_vm._v("Seleccione las Sucursales")]), _vm._v(" "), _c('div', {
    staticClass: "subsidiaries-grid"
  }, [_c('v-checkbox', {
    staticClass: "input-checkbox input-booking",
    attrs: {
      "label": "Seleccionar Todos",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.selectAll('subsidiaries', _vm.subsidiaries, _vm.allSubsidiary)
      }
    },
    model: {
      value: (_vm.allSubsidiary),
      callback: function($$v) {
        _vm.allSubsidiary = $$v
      },
      expression: "allSubsidiary"
    }
  }), _vm._v(" "), _vm._l((_vm.subsidiaries), function(subsidiary, indexSub) {
    return _c('v-checkbox', {
      key: indexSub,
      staticClass: "input-checkbox input-booking",
      attrs: {
        "hide-details": "",
        "value": subsidiary.isSelected,
        "label": subsidiary.sucursal_name
      },
      model: {
        value: (_vm.user.subsidiariesId),
        callback: function($$v) {
          _vm.user.subsidiariesId = $$v
        },
        expression: "user.subsidiariesId"
      }
    })
  })], 2)]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "mt-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": "",
      "d-flex": "",
      "justify-start": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-action btn-save white--text",
    attrs: {
      "disabled": !_vm.disabledBtn
    },
    on: {
      "click": _vm.saveCustomer
    }
  }, [_vm._v("\n\t\t\t\tGuardar\n\t\t\t")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70412370","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/users/New.vue
// module id = 1669
// module chunks = 3